export default window.unzer;